export default __webpack_public_path__ + "static/media/sunset_beach.cfe4e9ea.jpg";